import React, { Component } from 'react';
import {Navigate, Route, BrowserRouter,Routes } from 'react-router-dom';


import Home from '../pages/Home';
import Services from '../pages/Services';
import Contact from '../pages/Contact';
import Commentçamarche from '../pages/Commentçamarche';
import Mentions from '../pages/Mentionslegales';
import PC from '../pages/Politiqueconfidentialité';
import CGU from '../pages/CGU';
import Copyright from '../pages/Copyright';
import Error from '../pages/404';

class Router extends Component {


  render() {
    return (
					<BrowserRouter>
						<Routes>
							<Route path='/' element={<Home />} />
							<Route path='/services' element={<Services />} />
							<Route path='/commentçamarche' element={<Commentçamarche />} />
							<Route path='/contact' element={<Contact/>} />
							<Route path='/mentionslegales' element={<Mentions/>}/>
							<Route path='/politiquedeconfidentialite' element={<PC/>} />
							<Route path='/CGU' element={<CGU/>} />
							<Route path='/copyright' element={<Copyright/>} />
							<Route path='/404' element={<Error/>} />
							<Route path='*' element={<Navigate to='/404' replace />} />
						</Routes>
					</BrowserRouter>
				);
  }
}

export default Router;
